module.exports = __webpack_public_path__ + "static/ec-image-desktop-1217de15565bc1a5ba314683232db3f7.png";